import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { ModeloDocumento, ModeloDocumentoDados } from './modelo-documento.model'

@Injectable({ providedIn: 'root' })
export class ModeloDocumentoService {
  constructor(private http: HttpClient) {}

  listar(concursoId: number): Observable<ModeloDocumento[]> {
    return this.http.get<ModeloDocumento[]>(`${environment.baseUrlApi}/concurso/${concursoId}/modelos`)
  }

  obterDados(concursoId: number, tipo: string): Observable<ModeloDocumentoDados> {
    return this.http.get<ModeloDocumentoDados>(`${environment.baseUrlApi}/concurso/${concursoId}/modelos/${tipo}/dados`)
  }

  gerarPdf(concursoId: number, tipo: string, camposEditaveis: Record<string, string>): Observable<Blob> {
    return this.http.post(`${environment.baseUrlApi}/concurso/${concursoId}/modelos/${tipo}/pdf`, { camposEditaveis }, { responseType: 'blob' })
  }

  gerarDocx(concursoId: number, tipo: string, camposEditaveis: Record<string, string>): Observable<Blob> {
    return this.http.post(`${environment.baseUrlApi}/concurso/${concursoId}/modelos/${tipo}/docx`, { camposEditaveis }, { responseType: 'blob' })
  }
}
